<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"></app-header>
    <div class="sggs-dashboard-content">
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="iframe-container">
                <iframe src="https://project.gurugranthsahib.io/" frameborder="0" allowfullscreen></iframe>
              </div> -->
        <div class="w-embed w-iframe"><!--  Google Tag Manager (noscript)  -->
          <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MXMC3XM" height="0" width="0"
              style="display:none;visibility:hidden"></iframe></noscript>
          <!--  End Google Tag Manager (noscript)  -->
        </div>
        <div class="nav">
          <a href="http://sikhri.org" class="w-inline-block"><img src="assets/project/images/Logo.png" alt="Sikhri Logo"
              class="sikhri-logo"></a>
        </div>
        <div class="hero">
          <a href="https://www.gurugranthsahib.io" class="w-inline-block"><img
              src="assets/project/images/TGGSP---Logo-07.svg" alt="Guru Granth Sahib Logo" class="image-3"></a>
          <div class="hero-copy-div">
            <h1 class="h1">
              <p>The Guru Granth Sahib Project- A Global Translation and Transcreation Initiative</p>
            </h1>
            <h2 href="https://drive.google.com/file/d/10LNvos6bN5Sdn4AXvy2cga1HyxEyDrRo/view?usp=sharing"
              class="press-releases">Presenting the Guru Granth Sahib in contemporary English and Panjabi<br>Read the 31
              Aug 2020 <a href="https://drive.google.com/file/d/10We-9TKqjtQh4oKCGUWk3k04jFsCGqGc/view?usp=sharing"
                target="_blank">English</a> or <a
                href="https://drive.google.com/file/d/10YlBfJNts_6ILEVd05OdyNKWAqE0LToi/view?usp=sharing"
                target="_blank">Panjabi</a> Press Release<br>Read the 14 Mar 2020 <a
                href="https://drive.google.com/file/d/1AE3eUfVI8CFe00KZwrD6ZhlQSadCRiXr/view?usp=sharing"
                target="_blank">English</a> or <a
                href="https://drive.google.com/file/d/1LmOBU-ZDg1dXISbZo9oKqlohM4c-1238/view?usp=sharing"
                target="_blank">Panjabi</a> Press Release<br></h2>
          </div>
          <div class="hero-image">
            <div style="padding-top:56.17021276595745%" class="w-embed-youtubevideo youtube-2"><iframe
                loading="lazy"
                src="https://www.youtube.com/embed/x5Fd9BaE2GA?rel=0&amp;controls=1&amp;autoplay=0&amp;mute=0&amp;start=0"
                frameborder="0" style="position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:auto"
                allow="autoplay; encrypted-media" allowfullscreen=""
                title="Official Launch of the Guru Granth Sahib Project"></iframe></div>
          </div>
        </div>
        <div class="strip-2"></div>
        <div class="icons-section">
          <div class="icons-div">
            <div class="icon-individual-div l"><img src="assets/project/images/001-worldwide.svg" alt="World icon"
                class="icon">
              <h3 class="icon-copy">World’s first collaborative transcreation and commentary to showcase unique
                perspectives</h3>
            </div>
            <div class="icon-individual-div"><img src="assets/project/images/002-open-magazine.svg" alt="Book icon"
                class="icon">
              <h3 class="icon-copy">Freely open and available for the public to gain new accessibility to Guru Granth
                Sahib</h3>
            </div>
            <div class="icon-individual-div r"><img src="assets/project/images/003-handshake.svg" alt="Handshake icon"
                class="icon hands">
              <h3 class="icon-copy">Reinvigorating connection with cultural history and interpretation by initiating an
                ongoing project</h3>
            </div>
          </div>
        </div>
        <div class="strip-3">
          <div class="inner-div purpose-inner">
            <div class="col">
              <div class="purpose-copy-div">
                <h3 class="heading">The Guru Granth Sahib is not being consulted for its potential benefit to humanity,
                  largely due to its inaccessibility.</h3>
                <div class="subhead">Further, there are distortions and willful misrepresentations that alter and
                  corrupt the Guru’s message over time.</div>
                <div class="spacer25"></div>
              </div>
            </div>
            <div class="col _1-image">
              <div class="image-placeholder"><img
                  src="assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4.jpg"
                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 81vw, 38vw"
                  srcset="assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4-p-500.jpeg 500w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4-p-800.jpeg 800w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4-p-1080.jpeg 1080w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4-p-1600.jpeg 1600w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4-p-2000.jpeg 2000w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview4.jpg 2388w"
                  alt="Booklet image" class="image-7"></div>
            </div>
          </div>
        </div>
        <div class="strip-3 purpose-strip-2">
          <div class="inner-div purpose-inner pi2">
            <div class="col image-2">
              <div class="image-placeholder peoplepic"><img
                  src="assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview.jpg"
                  sizes="(max-width: 479px) 100vw, (max-width: 767px) 77vw, (max-width: 991px) 76vw, 38vw"
                  srcset="assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview-p-500.jpeg 500w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview-p-800.jpeg 800w, assets/project/images/The-Guru-Granth-Sahib-Project-Booklet---Preview.jpg 907w"
                  alt="Decorative image" class="image-8"></div>
            </div>
            <div class="col">
              <div class="purpose-copy-div">
                <h3 class="heading">Through The Guru Granth Sahib Project, people around the world can build a deeper
                  connection that they couldn’t before.</h3>
                <div class="subhead">Many Sikhs, particularly in the diaspora, do not engage with Panjabi content, and
                  some may not even have access to the Guru Granth Sahib. <br><br>This project serves not only as a
                  conduit for all individuals seeking to understand Gurbani, but it bridges the gap for experts working
                  on translating the Guru Granth Sahib into various languages using English as an intermediary.
                  <br><br>This research opens the door for subsequent transcreation of the translated content into
                  languages like Mandarin, Farsi, or Spanish, originating from the English version.</div>
                <div class="spacer25"></div>
              </div>
            </div>
          </div>
          <div class="hero-image bottom-video">
            <div data-autoplay="true" data-loop="true" data-wf-ignore="true"
              data-poster-url="https://uploads-ssl.webflow.com/5db2238fbc53f8e367cb2499/5f5bd703cf2a6044109b7874_Sim V (1)-poster-00001.jpg"
              data-video-urls="https://uploads-ssl.webflow.com/5db2238fbc53f8e367cb2499/5f5bd703cf2a6044109b7874_Sim V (1)-transcode.mp4,https://uploads-ssl.webflow.com/5db2238fbc53f8e367cb2499/5f5bd703cf2a6044109b7874_Sim V (1)-transcode.webm"
              class="simulation-video w-background-video w-background-video-atom"><video
                id="4a547bf2-013f-4ecf-032e-c72c14e20ede-video" autoplay="" loop=""
                style="background-image:url(&quot;https://uploads-ssl.webflow.com/5db2238fbc53f8e367cb2499/5f5bd703cf2a6044109b7874_Sim V (1)-poster-00001.jpg&quot;)"
                muted="" playsinline="" data-wf-ignore="true" data-object-fit="cover">
                <source
                  src="https://uploads-ssl.webflow.com/5db2238fbc53f8e367cb2499/5f5bd703cf2a6044109b7874_Sim V (1)-transcode.mp4"
                  data-wf-ignore="true">
                <source
                  src="https://uploads-ssl.webflow.com/5db2238fbc53f8e367cb2499/5f5bd703cf2a6044109b7874_Sim V (1)-transcode.webm"
                  data-wf-ignore="true">
              </video></div>
            <div class="video-prompt">
              <a href="https://app.gurugranthsahib.io" target="_blank" class="link-2"><span class="text-span">Start
                  Exploring Now ⟶</span></a>
            </div>
          </div>
        </div>
        <div class="quote-section">
          <div class="quote-div">
            <div class="quote-copy">ਪੀਊ ਦਾਦੇ ਕਾ ਖੋਲਿ ਡਿਠਾ ਖਜਾਨਾ ॥<br>ਤਾ ਮੇਰੈ ਮਨਿ ਭਇਆ ਨਿਧਾਨਾ ॥੧॥<br>When I opened to see
              the ancestral treasure, <br>then my mind was filled with enrichment.<br></div>
            <div class="quote-author quote1">Guru Granth Sahib 185<br></div>
          </div>
        </div>
        <div class="equation">
          <div class="equation-inner-div">
            <h3 class="heading eqheading">Our work is driven by an intersection of perspectives</h3>
            <div class="div-block">
              <div class="equation-item"><img src="assets/project/images/like.svg" alt="Like icon" class="eq-item-icon">
                <div class="eq-item-head">Values</div>
              </div>
              <div class="equation-item"><img src="assets/project/images/brain.svg" alt="Brain icon"
                  class="eq-item-icon">
                <div class="eq-item-head">Wisdom</div>
              </div>
              <div class="equation-item"><img src="assets/project/images/transfer.svg" alt="Transfer icon"
                  class="eq-item-icon">
                <div class="eq-item-head">Diversity</div>
              </div>
              <div class="equation-item"><img src="assets/project/images/idea.svg" alt="Idea icon" class="eq-item-icon">
                <div class="eq-item-head">Technology</div>
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="inner-div value-prop-inner">
            <div class="value-prop-copy-div">
              <div class="accent-text white-accent">OUR BELIEF</div>
              <h2 class="heading purpose-heading">We believe we can strengthen our connection to Sabad</h2>
              <div class="body purpose-body">Through <a href="https://app.gurugranthsahib.io/" target="_blank">The Guru
                  Granth Sahib Project</a>, individuals from across the globe gain the opportunity to forge a more
                profound connection than was previously possible. This initiative is particularly significant
                considering the successive generations of Sikhs in the diaspora who are minimally exposed to Panjabi and
                Sikh content. The universal messages and timeless wisdom of Sabad are trapped behind people&#x27;s
                disconnection with the script and lexicon of the time.<br></div>
            </div>
          </div>
        </div>
        <div class="section-2"></div>
        <div class="section-3">
          <div class="inner-div process-inner-div">
            <div class="col">
              <div class="accent-text">PROCESS</div>
              <h3 class="heading">Our team is engaged in a research-driven translation process. By meticulously delving
                into the root and etymology of each word within every sentence, they construct meaning by considering
                the context surrounding those words.</h3>
              <div class="spacer25"></div>
              <div class="research-style rs1">
                <h4 class="heading rsh">Tradition —</h4>
                <div class="body rsb">Instead of working on the Guru Granth Sahib from cover to cover, the project
                  follows the tradition of working by Bani.</div>
              </div>
              <div class="spacer25"></div>
              <div class="research-style">
                <h4 class="heading rsh">Collaboration —</h4>
                <div class="body rsb">This unprecedented transcreation project requires new modes of collaboration
                  through digital solutions.</div>
              </div>
              <div class="spacer25"></div>
              <div class="research-style rs3">
                <h4 class="heading rsh">Annotations —</h4>
                <div class="body rsb">Much of the work will be in making annotations on the Panjabi side, which will
                  then fuel the transcreation in English.</div>
              </div>
              <div class="spacer25"></div>
              <h4 class="heading process-h">By analyzing each word, we provide meanings and context in addition to
                definitions. Proceeding line by line and stanza by stanza, we ensure that each interpretation is
                enriched with the highest level of context for comprehensive understanding.<br></h4>
              <div class="button-div">
                <a data-w-id="4cd17c54-fc10-8fae-e130-0110026c9cc5" class="button w-button"
                  (click)="scrollToSection('TEAMLINK')">Meet the Team ⟶</a>
                <div class="button-line"></div>
                <div style="width:0PX" class="gold-button-line"></div>
              </div>
            </div>
            <div class="col colmargtop">
              <div class="ip6"><img src="assets/project/images/Earth.png"
                  sizes="(max-width: 479px) 250px, (max-width: 767px) 400px, 500px"
                  srcset="assets/project/images/Earth-p-500.png 500w, assets/project/images/Earth-p-800.png 800w, assets/project/images/Earth.png 893w"
                  alt="Earth image" class="image-10"></div>
            </div>
          </div>
        </div>
        <div class="quote-section">
          <div class="quote-div">
            <div class="quote-copy">ਪੋਥੀ ਪਰਮੇਸਰ ਕਾ ਥਾਨੁ ॥<br>ਸਾਧਸੰਗਿ ਗਾਵਹਿ ਗੁਣ ਗੋਬਿੰਦ<br>ਪੂਰਨ ਬ੍ਰਹਮ ਗਿਆਨੁ ॥੧॥ ਰਹਾਉ
              ॥<br>The wisdom in the text is the abode of 1-Supreme-Being. Singing virtues of 1-Earth-Knower in company
              of spiritual beings, the wisdom about 1-Absolute is received. Pause-reflect.<br></div>
            <div class="quote-author">Guru Granth Sahib 1226<br></div>
          </div>
        </div>
        <div class="section-5">
          <div class="inner-div process-inner-div technology-inner">
            <div class="col image-coo">
              <div class="ip7"><img src="assets/project/images/ik-onkar.png" alt="Onkar image" class="image-6"></div>
            </div>
            <div class="col tech-col-2">
              <div class="accent-text">TECHNOLOGY</div>
              <h4 class="heading"><strong>Our work is focused on the IkOankar paradigm to create a rich understanding:
                  provide a new way to explore and develop a relationship with the Sabad (Wisdom).</strong><br></h4>
              <div class="body tech-body">This initiative is designed for seekers and scholars alike. It requires
                exploring each word of the Guru Granth Sahib to form a complete and comprehensive dictionary (etymology,
                grammar, meaning).<br><br>Our live, searchable website in Panjabi (Gurmukhi script) and English displays
                what the user desires to see, from annotations to meanings at different levels to commentary.<br><br>By
                leveraging an interdisciplinary and collaborative research process our project discusses everything from
                word meanings to commentaries across multiple dimensions: language, aesthetics, musicology, history,
                culture, and philosophy.<br></div>
              <div class="button-div">
                <a href="https://app.gurugranthsahib.io" data-w-id="f1be4a56-81c0-796b-4684-1c6a7e6ecabe"
                  target="_blank" class="button w-button">Start exploring now ⟶</a>
                <div class="button-line"></div>
                <div style="width:0PX" class="gold-button-line"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="timeline-section">
          <div class="left-spacer-div"></div>
          <div class="timeline-left-col-div">
            <div class="timeline-copy-div">
              <div class="value-prop-copy-div">
                <div id="TIMELINE-LINK" class="timelinelink"></div>
                <div class="accent-text white-accent">Milestones</div>
                <h2 class="heading purpose-heading">Our Progress to Date</h2>
              </div>
              <div class="w-dyn-list">
                <div role="list" *ngIf="selectedMilestone else noMilestones;" class="w-dyn-items">
                  <div role="listitem" class="collection-item-3 w-dyn-item"></div>
                </div>
                <ng-template #noMilestones>
                  <div class="w-dyn-empty">
                    <div>No items found.</div>
                  </div>
                </ng-template>
              </div>
              <div class="div-block-7">
                <div class="timeline-container-div">
                  <div class="date-{{i}} w-dyn-list" *ngFor="let milestone of milestones;let i =index;">
                    <div *ngIf="selectedMilestone else noMilestones;" role="list" class="w-dyn-items">
                      <div role="listitem" class="collection-item-{{i}} w-dyn-item">
                        <div class="date-div">
                          <div class="timeline-scroll-container"></div>
                          <div class="tl-date inner">{{ selectedMilestone['tl-date inner'] }}</div>
                        </div>
                        <div class="august-2001 vj">
                          <p class="tl-description">{{ selectedMilestone['tl-description'] }}</p>
                        </div>
                      </div>
                    </div>
                    <ng-template #noMilestones>
                      <div class="w-dyn-empty">
                        <div>No items found.</div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dates-click-div">
            <div class="_{{i}}th-date" *ngFor="let milestone of milestones;let i =index;"
              (click)="selectMilestone(milestone)">
              <div data-w-id="50ddb08b-7285-613b-3152-3a8dac64c49e" class="date-nav-div">
                <div data-w-id="50ddb08b-7285-613b-3152-3a8dac64c49f" class="tl-date">{{ milestone['tl-date'] }}</div>
                <div class="date-nav-line"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="sme-s-section">
          <div id="TEAMLINK" class="team-link"></div>
          <div class="inner-div sme-inner">
            <h3 class="heading smeh">This project requires many diverse minds. Our team will grow as necessary to
              deliver the best possible outcomes.</h3>
          </div>
          <div class="sme-s-div">
            <div class="team-names">Core Team</div>
            <div class="collection-list-wrapper w-dyn-list">
              <div role="list" *ngIf="teamDetails && teamDetails.length > 0; else noCoreTeamMembers"
                class="collection-list w-dyn-items w-row">
                <div role="listitem" *ngFor="let member of  getCoreTeamMembers();let i = index;"
                  class="collection-item w-dyn-item w-col w-col-4">
                  <div class="core-team">
                    <div class="div-block-5">
                      <img
                        alt="{{member.FirstName}} {{member.LastName}} Image, {{member.ProjectRole}}, {{member.Location}}"
                        src="{{member.UserImage}}" class="expert-mobile-photo">
                      <div class="expertphoto" style="background-image:url(&quot;{{member.UserImage}}&quot;)"></div>
                      <h5 class="heading sme-name">{{member.FirstName}} {{member.LastName}}</h5>
                      <div class="location">{{member.Location}}</div>
                      <div class="sme-role">{{member.ProjectRole}}</div>
                      <div class="sme-title">{{member.Title}}</div>
                      <div class="sme-bio">{{member.Background}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noCoreTeamMembers>
                <div class="w-dyn-empty">
                  <div>No items found.</div>
                </div>
              </ng-template>
            </div>
            <div class="team-names">Strategic Advisors</div>
            <div class="w-dyn-list">
              <div role="list" *ngIf="teamDetails && teamDetails.length > 0; else noStrategicTeamMembers"
                class="collection-list w-dyn-items w-row">
                <div role="listitem" *ngFor="let member of  getStrategicTeamMembers();let i = index;"
                  class="collection-item w-dyn-item w-col w-col-4">
                  <div class="strategic-advisors">
                    <div class="div-block-5">
                      <img
                        alt="{{member.FirstName}} {{member.LastName}} Image, {{member.ProjectRole}}, {{member.Location}}"
                        src="{{member.UserImage}}" class="expert-mobile-photo w-dyn-bind-empty">
                      <div class="expertphoto" style="background-image:url(&quot;{{member.UserImage}}&quot;)"></div>
                      <h5 class="sa---heading sme-name">{{member.FirstName}} {{member.LastName}}</h5>
                      <div class="sa---location">{{member.Location}}</div>
                      <div class="sa---role">{{member.ProjectRole}}</div>
                      <div class="sa---title">{{member.Title}}</div>
                      <div class="sme-bio color-white">{{member.Background}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noStrategicTeamMembers>
                <div class="w-dyn-empty">
                  <div>No items found.</div>
                </div>
              </ng-template>
            </div>
            <div class="team-names" *ngIf="hasProjectTeamCategory()">Project Team</div>
            <div class="w-dyn-list">
              <div role="list" *ngIf="teamDetails && teamDetails.length > 0; else noProjectTeamMembers"
                class="collection-list w-dyn-items w-row">
                <div role="listitem" *ngFor="let member of  getProjectTeamMembers();let i = index;"
                  class="collection-item w-dyn-item w-col w-col-4">
                  <div class="project-team">
                    <div class="div-block-5">
                      <h5 class="heading sme-name">{{member.FirstName}}</h5>
                      <div class="location">{{member.Location}}</div>
                      <div class="sme-role">{{member.ProjectRole}}</div>
                      <div class="sme-title">{{member.Title}}</div>
                      <div class="sme-bio">{{member.Background}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noProjectTeamMembers>
                <div class="w-dyn-empty">
                  <div>No items found.</div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="promise-section">
          <div class="inner-div-promise">
            <div class="accent-text">Our PROMISE</div>
            <h3 class="heading _10yp">We will expand the reach of the Sabad, making its wisdom universally accessible
              for everyone.<br></h3>
            <div class="spacer25"></div>
            <div class="body _10yp">As fresh segments of the Guru Granth Sahib are presented via this endeavor, rendered
              in modern English and Punjabi accompanied by explanatory interpretations and contextual material, we
              persist in sharing them openly and freely online, aligning with the original intent of the Guru Granth
              Sahib.<br></div>
            <div class="spacer25"></div>
            <div class="body _10yp"></div>
          </div>
        </div>
        <div class="my-5">
          <app-newsletter></app-newsletter>
        </div>
        <div class="footer old-footer">
          <div class="div-block-3">
            <div class="footer-col left">
              <h2 class="footer-head">Follow Us</h2>
              <div class="social-div">
                <a href="https://www.facebook.com/sikhresearchinstitute" target="_blank" class="w-inline-block"><img
                    src="assets/project/images/002-facebook-logo.svg" alt="facebook logo" class="image-4"></a>
                <a href="https://www.instagram.com/sikh.research.institute/" target="_blank" class="w-inline-block"><img
                    src="assets/project/images/instagram-logo.svg" alt="instagram logo" class="image-4"></a>
              </div>
              <div class="social-div">
                <a href="https://twitter.com/SikhRI" target="_blank" class="w-inline-block"><img
                    src="assets/project/images/001-twitter.svg" alt="twitter logo" class="image-4"></a>
                <a href="https://open.spotify.com/show/1CNFeRMFvlDNERzomNT2p9?si=VNJIFzLYSH6dhwvZg6CNAQ" target="_blank"
                  class="w-inline-block"><img src="assets/project/images/004-spotify.svg" alt="spotify logo"
                    class="image-4"></a>
              </div>
            </div>
            <div class="footer-col">
              <h2 class="footer-head">Sikh Research Institute</h2>
              <div class="footer-copy">
                <a href="tel:18559131313" class="footer-link">1-855-913-1313</a>
              </div>
              <div class="footer-copy">
                <a href="mailto:info@sikhri.org?subject=Website%20Contact" class="footer-link">{{ infoEmailID }}</a>
              </div>
              <div class="footer-copy add">470 Schooleys Mt Road, Ste 614<br>Hackettstown, NJ 07840<br>USA<br><br>501c3
                Tax ID #: 41-2090424<br></div>
            </div>
            <div class="footer-col">
              <h2 class="footer-head">Sikh Research Institute Canada</h2>
              <div class="footer-copy">
                <a href="tel:18559131313" class="footer-link">1-855-913-1313</a>
              </div>
              <div class="footer-copy">
                <a href="mailto:info@sikhri.org" class="footer-link">{{ infoEmailID }}</a>
              </div>
              <div class="footer-copy add">5307 Victoria Drive, Unit #284<br>Vancouver, BC V5P
                3V6<br>Canada<br><br>Charity #: 81902 1692 RR0001<br></div>
            </div>
          </div>
        </div>

      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>